import { RcClasses } from '../../../../foundation';
export var RcListItemAvatarClasses = RcClasses([], 'RcListItemAvatar');
